import React from 'react'
import { router, usePage, useForm } from '@inertiajs/react'
import {
  Box, Button, TextField, Select, MenuItem, FormControl, InputLabel,
  Paper, Grid,
} from '@mui/material'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Edit.layout = (page) => <AppShell>{page}</AppShell>

export default function Edit({ property, resolution, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}

  const { data, setData, put, processing, errors } = useForm({
    title: resolution.title || '',
    resolution_text: resolution.resolution_text || '',
    date: resolution.date || '',
    status: resolution.status || 'accepted',
    voting_method: resolution.voting_method || 'head_count',
    majority_requirement: resolution.majority_requirement || 'simple_majority',
    votes_for: resolution.votes_for || '',
    votes_against: resolution.votes_against || '',
    abstentions: resolution.abstentions || '',
    challenge_deadline: resolution.challenge_deadline || '',
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    put(`/m/${tenant.slug}/properties/${property.id}/resolutions/${resolution.id}`)
  }

  return (
    <Box>
      <PageHeader
        title={`Beschluss #${resolution.resolution_number} bearbeiten`}
        breadcrumbs={[
          { label: 'Beschlusssammlung', href: `/m/${tenant.slug}/properties/${property.id}/resolutions` },
          { label: `#${resolution.resolution_number}`, href: `/m/${tenant.slug}/properties/${property.id}/resolutions/${resolution.id}` },
          { label: 'Bearbeiten' },
        ]}
      />
      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 700 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField label="Titel" required fullWidth size="small"
                value={data.title} onChange={(e) => setData('title', e.target.value)}
                error={!!allErrors.title} helperText={allErrors.title?.[0]} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Beschlusstext" required fullWidth size="small" multiline rows={4}
                value={data.resolution_text} onChange={(e) => setData('resolution_text', e.target.value)}
                error={!!allErrors.resolution_text} helperText={allErrors.resolution_text?.[0]} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Ja-Stimmen" type="number" fullWidth size="small"
                value={data.votes_for} onChange={(e) => setData('votes_for', e.target.value)} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Nein-Stimmen" type="number" fullWidth size="small"
                value={data.votes_against} onChange={(e) => setData('votes_against', e.target.value)} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Enthaltungen" type="number" fullWidth size="small"
                value={data.abstentions} onChange={(e) => setData('abstentions', e.target.value)} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Anfechtungsfrist" type="date" fullWidth size="small"
                value={data.challenge_deadline} onChange={(e) => setData('challenge_deadline', e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }} />
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined"
              onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/resolutions/${resolution.id}`)}>
              Abbrechen
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
